import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// Phase 3 & 4----------------------------------------------------------------------------------------

// récupérer les réclamations d'une période d'évaluation
export const getAllClaimByEvaluationPeriod = async (
  id_evaluationPeriod,
  id_academicYear,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/claim/claimsByEvaluationPeriod/${id_evaluationPeriod}/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// créer une réclamation
export const createStudentClaim = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/claim/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getStudentClaims = async (id_academicYear, idStudent, context) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/claim/studentClaims/${id_academicYear}/${idStudent}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer une réclamation par son id
export const getClaimById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/claim/getById/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// archiver une réclamation
export const archiveClaim = async (id, archived, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/claim/archived/${id}`,
    { archived },
    { headers: setHeaders(context) },
  );
  return response.data;
};

// mettre à jour le statut par l'étudiant
export const updateStatutClaimByStudent = async (id, statut_claim, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/claim/updateStatutByStudent/${id}`,
    { statut_claim },
    { headers: setHeaders(context) },
  );
  return response.data;
};

// mettre à jour le statut par l'admin
export const updateStatutClaimByAdmin = async (id, statut_claim, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/claim/updateStatutByAdmin/${id}`,
    { statut_claim },
    { headers: setHeaders(context) },
  );
  return response.data;
};

// --- Réponses aux réclamations ---

// créer une réponse
export const createAnswerClaim = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + "/api/answerClaim/create",
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// modifier une réponse
export const updateAnswerClaim = async (id, description, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/answerClaim/update/${id}`,
    { description },
    { headers: setHeaders(context) },
  );
  return response.data;
};

// supprimer une réponse
export const deleteAnswerClaim = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/answerClaim/delete/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};
